import { adminPost } from "@/lib/kbAdminClient";
import type { OrgEntitlementRow, OrgSubscriptionStatus } from "@/lib/platform/orgSubscriptionCatalog";

const SUBSCRIPTIONS_ACTION = "/api/platform/org-subscriptions";

export type OrgSubscriptionsResult<T> = { ok: true; data: T } | { ok: false; error: string };

async function postSubscriptions<T>(body: unknown): Promise<OrgSubscriptionsResult<T>> {
  const res = await adminPost<T>(SUBSCRIPTIONS_ACTION, body);
  if (!res.ok) return { ok: false, error: res.error };
  return { ok: true, data: res.data };
}

export function listOrgSubscriptions(organizationId: string) {
  return postSubscriptions<{ ok: true; rows: OrgEntitlementRow[] }>({
    op: "list",
    organization_id: organizationId,
  });
}

export function upsertOrgSubscription(input: {
  organizationId: string;
  addonKey: string;
  status: OrgSubscriptionStatus;
  notes: string;
}) {
  return postSubscriptions<{ ok: true; row: OrgEntitlementRow }>({
    op: "upsert",
    organization_id: input.organizationId,
    addon_key: input.addonKey,
    status: input.status,
    notes: input.notes,
  });
}
